export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function uniq(array: string[]) {
  return [...new Set(array)];
}

export function formatPhone(phone?: string) {
  if (phone) {
    return phone?.replace(/[^+\d]/g, '');
  }
  return '';
}

export function isExist<T = any>(value: T, array: T[]) {
  return array.find(v => v === value);
}
